import { configureStore } from '@reduxjs/toolkit'
import counterReducer from './slices/counterSlice'
import toastReducer from './slices/toastSlice'
import activeCompanyReducer from './slices/activeCompanySlice'
import { saveCompanyId } from './activeCompanyStorage'

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    toast: toastReducer,
    activeCompany: activeCompanyReducer,
  },
})

// La sociedad activa se guarda en el navegador cada vez que cambia
let lastSavedCompany: string | null = null
store.subscribe(() => {
  const activeId = store.getState().activeCompany.activeId
  if (activeId && activeId !== lastSavedCompany) {
    lastSavedCompany = activeId
    saveCompanyId(activeId)
  }
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {counter: CounterState}
export type AppDispatch = typeof store.dispatch

export default store
